export default __webpack_public_path__ + "static/media/clip_board.d025b4ce.svg";